<template>
  <div>
    <v-tooltip bottom :max-width="280" v-if="tooltip !== false">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" :style="{ height: height }">
          <v-icon :size="height" :color="color">
            icon-owner
          </v-icon>
        </div>
      </template>
      <span>{{ tooltip || defaultTooltip }}</span>
    </v-tooltip>
    <v-icon v-else :size="height" :color="color">
      icon-owner
    </v-icon>
  </div>
</template>

<script>
export default {
  name: "IsOwnerIndicator",
  props: {
    isOwner: {
      type: Boolean,
      required: true
    },
    height: {
      type: String,
      default: "22px"
    },
    tooltip: {
      type: [String, Boolean],
      default: ""
    }
  },
  computed: {
    color() {
      return this.isOwner ? "primary" : "text-muted";
    },
    defaultTooltip() {
      return this.$t(
        `message.common.facilityIs${this.isOwner ? "" : "Not"}OwnerTooltip`
      );
    }
  }
};
</script>
